<div class="grid-container">
  <div class="product-card-container" *ngFor="let i of [1, 2, 3, 4, 5, 6]">
    <app-product-card class="product-card"></app-product-card>
  </div>
</div>
